import { BaseApiClient } from './base-client'
import { API_ROUTES, ApiResponse, ActivationStatus } from '@super/shared-types'
import { withErrorHandling } from '../utils'
import type { WorkOSUser } from '@super/shared-types'

export interface UserContextResponse {
  authenticated: boolean
  user?: WorkOSUser
  organization?: {
    id: string
    name: string
    organizationId: string | null
  }
  isSuperAdmin?: boolean
  isPartner?: boolean
  featureFlags?: string[]
  activationStatus?: ActivationStatus
  /** Inbound email domain (EMAIL_DOMAIN env), used to derive `{slug}@{domain}`. */
  emailDomain?: string
  reason?: string
  error?: string
}

export class UserContextApiClient extends BaseApiClient {
  async getUserContext(): Promise<UserContextResponse | null> {
    return withErrorHandling(
      async () => {
        const response = await this.request<ApiResponse<UserContextResponse>>(
          API_ROUTES.AUTH.USER_CONTEXT,
        )
        return response.data || null
      },
      {
        onApiError: 'log-and-return-null',
        onOtherError: 'log-and-return-null',
        errorContext: 'Error fetching user context',
      },
    )
  }
}

export const userContextApiClient = new UserContextApiClient()
